module.exports = __webpack_public_path__ + "static/fonts/aeonik-black.2074a9dd.woff";